(function () {
  "use strict";


  /* ============================================================
     SILVER GARDENS
     SINGLE PLANT MEDIA LOCK V4

     IMPORTANT:

     Desktop media switching is intentionally NOT controlled
     here.

     Stiletto handles desktop variant images natively.

     This script only:

     1. Identifies Single Plant product
     2. Adds our media-lock class
     3. Locks the mobile Swiper
     4. Makes mobile variant switching instant

     No MutationObserver.
     No desktop image manipulation.
     No .hidden class manipulation.
     ============================================================ */


  /* ==========================================================
     FIND PRODUCT
     ========================================================== */

  function getProduct() {

    var configurator =
      document.querySelector(
        ".sg-native-configurator"
      );


    if (!configurator) {
      return null;
    }


    return configurator.closest(
      ".product"
    );

  }


  /* ==========================================================
     LOCK MOBILE CAROUSEL
     ========================================================== */

  function lockMobileSwiper(product) {

    if (!product) {
      return;
    }


    /* --------------------------------------------------------
       Tell Stiletto that mobile carousel looping and
       pagination dots are not wanted.
       -------------------------------------------------------- */

    product.setAttribute(
      "data-loop-mobile-carousel",
      "false"
    );


    product.setAttribute(
      "data-hide-mobile-carousel-dots",
      "true"
    );


    /* --------------------------------------------------------
       Find Stiletto's initialized mobile Swiper.
       -------------------------------------------------------- */

    var swipers =
      product.querySelectorAll(
        ".product__media-container.below-mobile .swiper"
      );


    swipers.forEach(
      function (swiperElement) {

        var swiper =
          swiperElement.swiper;


        /*
         * Swiper may not yet be initialized.
         *
         * The delayed initialise calls below will try again.
         */

        if (!swiper) {
          return;
        }


        /* ----------------------------------------------------
           Prevent manual left/right customer swiping.
           ---------------------------------------------------- */

        swiper.allowTouchMove =
          false;


        /* ----------------------------------------------------
           Update live Swiper parameters.

           speed = 0 is the important part.

           Stiletto calls:

             swiper.slideTo(index)

           when the Shopify variant changes.

           With speed = 0 the correct image appears instantly
           instead of sliding across the screen.
           ---------------------------------------------------- */

        if (swiper.params) {

          swiper.params.allowTouchMove =
            false;

          swiper.params.loop =
            false;

          swiper.params.speed =
            0;

        }


        /* ----------------------------------------------------
           Also update Swiper's stored original parameters.

           This prevents a later Swiper update from restoring
           the original transition speed.
           ---------------------------------------------------- */

        if (swiper.originalParams) {

          swiper.originalParams.allowTouchMove =
            false;

          swiper.originalParams.loop =
            false;

          swiper.originalParams.speed =
            0;

        }


        /* ----------------------------------------------------
           Set current Swiper speed directly too.
           ---------------------------------------------------- */

        swiper.speed =
          0;


        /* ----------------------------------------------------
           Kill any currently running transition.
           ---------------------------------------------------- */

        if (
          typeof swiper.setTransition ===
          "function"
        ) {

          swiper.setTransition(
            0
          );

        }


        /*
         * Keep Swiper measurements correct.
         */

        if (
          typeof swiper.update ===
          "function"
        ) {

          swiper.update();

        }

      }
    );

  }


  /* ==========================================================
     INITIALISE
     ========================================================== */

  function initialise() {

    var product =
      getProduct();


    if (!product) {
      return;
    }


    /*
     * Activates our CSS only on products containing
     * the Silver Gardens native configurator.
     */

    product.classList.add(
      "sg-single-plant-media-lock"
    );


    /*
     * Mobile only.
     *
     * Desktop is intentionally left entirely to Stiletto.
     */

    lockMobileSwiper(
      product
    );

  }


  /* ==========================================================
     INITIAL PAGE LOAD
     ========================================================== */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialise,
      {
        once: true
      }
    );

  }

  else {

    initialise();

  }


  /* ==========================================================
     STILETTO SWIPER INITIALISATION

     Stiletto may initialise its carousel slightly after our
     deferred asset runs.

     These retries do NOT alter images or variants.

     They only apply the instant-transition settings after
     Swiper exists.
     ========================================================== */

  requestAnimationFrame(
    initialise
  );


  setTimeout(
    initialise,
    100
  );


  setTimeout(
    initialise,
    250
  );


  setTimeout(
    initialise,
    500
  );


  setTimeout(
    initialise,
    1000
  );


  /* ==========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================== */

  document.addEventListener(
    "shopify:section:load",
    function () {

      requestAnimationFrame(
        initialise
      );


      setTimeout(
        initialise,
        150
      );

    }
  );


})();